import { setupWorker } from 'msw/browser';

import { env } from '../constants';
import { handlers } from '../mocks/browser';

const worker = env.MOCK_API ? setupWorker(...handlers) : undefined;

export default defineNuxtPlugin(async () => {
  if (!env.MOCK_API) return;
  await worker?.start({ onUnhandledRequest: 'bypass' });
});
